// The existing quick-reply picker only needs a display title and editable
// text. Canonical snippets currently have no attachments, so do not invent a
// provider media path or send one through the legacy media command.
export function snippetsForQuickReplyPicker(items) {
  return (Array.isArray(items) ? items : []).filter(item => item?.id && typeof item.body === "string" && !item.attachment).map(item => ({
    id: item.id,
    name: item.title || item.body.slice(0, 40) || "Quick reply",
    text: item.body,
    type: "text",
    canonical_id: item.id,
  }));
}
